// extracted by mini-css-extract-plugin
export var container = "_v6-0";
export var table = "_v6-2";
export var tableWrapper = "_v6-1";